import type { ReactNode } from 'react'

/** Sets ordinal suffixes in running text as superscripts, the way a typesetter would: "July 10th" -> July 10<sup>th</sup>. */
export function withOrdinals(text: string): ReactNode {
  const out: ReactNode[] = []
  let last = 0
  for (const m of text.matchAll(/(\d)(st|nd|rd|th)\b/g)) {
    const at = (m.index ?? 0) + m[0].length - m[2].length
    out.push(
      text.slice(last, at),
      <sup key={at} className="ordinal">
        {m[2]}
      </sup>,
    )
    last = at + m[2].length
  }
  if (!out.length) return text
  out.push(text.slice(last))
  // One inline box, so a flex parent's gap doesn't split "10" from its "th"
  return <span>{out}</span>
}
